import toast from '../../components/toast';

const DEFAULT_MESSAGE = 'Ubicación desactivada. Activa los permisos de ubicación en tu navegador'
  + ' para acceder a tu cuenta.';

const renderSessionWithoutGeolocation = message => toast.danger(message ?? DEFAULT_MESSAGE);

export default renderSessionWithoutGeolocation;
